import { formatDateHuman, formatTimestampHuman, parseDateRaw } from "../date-utils";
export const visitDtoFields = [{
        name: "statusIcon",
        title: "Stato",
        render: (record) => renderStatusIcon(record)
    }, {
        // name: "protocol",
        // title: "Macellazione",
        // render: (record: IVisitDTO) => record.sla
        // },{
        name: "slaughterDate",
        title: "Data",
        render: (record) => formatDateHuman(parseDateRaw(record.slaughterDate))
    }, {
        name: "dailyNumber",
        title: "Prog.Mac.",
        render: (record) => record.dailyNumber
    }, {
        name: "itemDailyProgressive",
        title: "Prog.Capo",
        render: (record) => record.itemDailyProgressive
    }, {
        name: "srcCod317",
        title: "Provenienza (cod.317)",
        render: (record) => record.srcCod317
    }, {
        name: "dstCustomerName",
        title: "Destinazione",
        render: (record) => record.dstCustomerName
    }, {
        name: "lotNumber",
        title: "Lotto",
        render: (record) => record.lotNumber
        // }, {
        //   name: "srcProductTypeName",
        //   title: "Tipologia Ingresso",
        //   render: (record: IVisitDTO) => record.srcProductTypeName
        // }, {
        //   name: "dstProductTypeName",
        //   title: "Tipologia Uscita",
        //   render: (record: IVisitDTO) => record.dstProductTypeName
    }, {
        name: "utilizationDescription",
        title: "Utilizzo",
        render: (record) => record.utilizationDescription
    }, {
        name: "utilizationNotes",
        title: "Note Utilizzo",
        render: (record) => record.utilizationNotes
    }, {
        name: "hotTransportExecuted",
        title: "Trasporto a caldo",
        titleClass: "has-text-centered",
        dataClass: "has-text-centered",
        render: (record) => `<i class="material-icons">${record.hotTransportExecuted === 1 ? "check" : ""}</i>`
    }, {
        name: "hotTransportCooled",
        title: "Trasporto con mezzo refrigerato",
        titleClass: "has-text-centered",
        dataClass: "has-text-centered",
        render: (record) => `<i class="material-icons">${record.hotTransportCooled === 1 ? "check" : ""}</i>`
    }, {
        name: "weight",
        title: "Peso [Kg]",
        render: (record) => record.weighed == 1 ? record.srcWeight : '--'
    }, {
        name: "printed",
        title: "Etic.",
        titleClass: "has-text-centered",
        dataClass: "has-text-centered",
        render: (record) => `<i class="material-icons">${record.printed === 1 ? "check" : ""}</i>`
    }];
export const visitHistoryDtoFields = [{
        name: "statusIcon",
        title: "Stato",
        render: (record) => renderStatusIcon(record)
    }, {
        // name: "protocol",
        // title: "Macellazione",
        // render: (record: IVisitDTO) => record.sla
        // },{
        name: "slaughterDate",
        title: "Data",
        render: (record) => formatDateHuman(parseDateRaw(record.slaughterDate))
    }, {
        name: "dailyNumber",
        title: "Prog.Mac.",
        render: (record) => record.dailyNumber
    }, {
        name: "itemDailyProgressive",
        title: "Prog.Capo",
        render: (record) => record.itemDailyProgressive
    }, {
        name: "itemMonthlyProgressive",
        title: "Prog.Men.",
        render: (record) => record.itemMonthlyProgressive
    }, {
        name: "itemYearlyProgressive",
        title: "Prog.Ann.",
        render: (record) => record.itemYearlyProgressive
    }, {
        name: "srcCod317",
        title: "Provenienza (cod.317)",
        render: (record) => record.srcCod317
    }, {
        name: "dstCustomerName",
        title: "Destinazione",
        render: (record) => record.dstCustomerName
    }, {
        name: "lotNumber",
        title: "Lotto",
        render: (record) => record.lotNumber
        // }, {
        //   name: "srcProductTypeName",
        //   title: "Tipologia Ingresso",
        //   render: (record: IVisitDTO) => record.srcProductTypeName
        // }, {
        //   name: "dstProductTypeName",
        //   title: "Tipologia Uscita",
        //   render: (record: IVisitDTO) => record.dstProductTypeName
    }, {
        name: "utilizationDescription",
        title: "Utilizzo",
        render: (record) => record.utilizationDescription
    }, {
        name: "utilizationNotes",
        title: "Note Utilizzo",
        render: (record) => record.utilizationNotes
    }, {
        name: "hotTransportExecuted",
        title: "Trasporto a caldo",
        titleClass: "has-text-centered",
        dataClass: "has-text-centered",
        render: (record) => `<i class="material-icons">${record.hotTransportExecuted === 1 ? "check" : ""}</i>`
    }, {
        name: "hotTransportCooled",
        title: "Trasporto con mezzo refrigerato",
        titleClass: "has-text-centered",
        dataClass: "has-text-centered",
        render: (record) => `<i class="material-icons">${record.hotTransportCooled === 1 ? "check" : ""}</i>`
    }, {
        name: "weight",
        title: "Peso [Kg]",
        render: (record) => record.weighed == 1 ? record.srcWeight : '--'
    }, {
        name: "printed",
        title: "Etic.",
        titleClass: "has-text-centered",
        dataClass: "has-text-centered",
        render: (record) => `<i class="material-icons">${record.printed === 1 ? "check" : ""}</i>`
    }];
function renderStatusIcon(record) {
    if (record.worked == 0 && record.skipped == 0)
        return '<i class="material-icons" title="Attesa lavorazione">autorenew</i>';
    if (record.skipped == 1)
        return '<i class="material-icons" title="Annullato">close</i>';
    if (record.viewed == 0)
        return '<i class="material-icons" title="Attesa controllo sanitario">question_mark</i>';
    if (record.viewed == 1 && record.passed == 1)
        return '<i class="material-icons" title="Completato">done_outline</i>';
    if (record.viewed == 1 && record.locked == 1)
        return '<i class="material-icons" title="Vincolo sanitario">block</i>';
    if (record.viewed == 1 && record.locked == 0 && record.passed == 0)
        return '<i class="material-icons" title="Scartato">report</i>';
    return '<i class="material-icons" title="Errore">error</i>';
}
